{
  "loading": "Carregant",
  "howToPlay": "Com jugar:",
  "howToPlayControls": "- Fletxes: Moviment\n- Tecla A: Acció",
  "pressToStart": "Prem la tecla A o toca la pantalla per començar",
  "wardrobe1": "La meva roba és aquí, a veure si trobo la meva samarreta vermella...",
  "wardrobe2": "Aquí és la samarreta! Agafo també la resta de roba... Ja ho tinc tot!",
  "wardrobe3": "Ja he agafat la roba!",
  "wardrobeNoClothes": "Roba i més roba... però aquí no hi ha res que sigui meu!",
  "bathroom1": "Hora de dutxar-se!",
  "bathroomFail1": "Abans de dutxar-me, necessito agafar la roba que em posaré. La roba és a un dels armaris de l'habitació.",
  "likeNew": "Ja estic preparat. Em sento molt millor!",
  "wakeUpFreeman": "Desperti, senyor Freeman..., desperti i miri al seu voltant...",
  "wakeUpAlbert": "... Vull dir, Albert! Desperta o faràs tard a la feina!",
  "ellipsis": "...",
  "ellipsisX2": "......",
  "rightNow": "Sí... Ara mateix em llevo.",
  "walkCobi": "Vaig a passejar a Cobi, i quan torni jo també marxaré a la feina. Fins després!",
  "bark": "Guau!",
  "prepare": "Bé, m'he de preparar: Primer m'he de dutxar i després he d'agafar el portàtil abans de sortir cap a la feina.",
  "prepare2": "Usa Les fletxes per controlar el personatge i la lletra A per interactuar amb objectes. Amb La lletra M es pot obrir el menú, que també es controla amb les fletxes i A.",
  "prepare3": "Amb la lletra S es pot activar/desactivar el so. Per últim, amb la lletra F es pot activar/desactivar el mode a pantalla completa.",
  "prepare4": "És la teva oportunitat, investiga pel mapes i pel menú del joc per saber més de mi!",
  "shelves1": "Aquí hi ha llibres de tota mena. El que més m'agrada llegir és literatura fantàstica i de ciència ficció, però puc llegir altres tipus de llibres sense problemes.",
  "shelves2": "Videojocs i més videojocs. Són un dels meus hobbies favorits. La meva primera consola va ser l'Atari 2600, i des de llavors he continuat jugant tant a jocs de consola com d'ordinador.",
  "shelves3": "Aquí tinc alguns llibres sobre tecnologia i metodologia. M'agrada aprendre coses noves, ja sigui llegint o desenvolupant projectes, com aquest joc al qual estàs jugant ara mateix :)",
  "shelves4": "Aquí tinc algunes figuretes. No sóc cap col·leccionista, però sí que m'agrada de tant en tant agafar figuretes de temes que m'agraden.",
  "noeDesktop": "L'escriptori de Noe. No tinc poder aquí.",
  "albertDesktop": "El meu escriptori. Aquí passo moltes hores! El meu portàtil de la feina és aquí, l'agafo, que el necessito per poder treballar a l'oficina.",
  "albertDesktopFail": "El meu escriptori. Aquí passo moltes hores! El meu portàtil de la feina és aquí, però abans de poder agafar-ho, m'he de dutxar.",
  "albertDesktop2": "El meu escriptori. Aquí passo moltes hores!",
  "tv": "La TV! Aquí és on mirem sèries i pel·lícules. I per descomptat, també jugo a videojocs.",
  "couch": "Que bé que s'hi està al sofà! Però ara no tinc temps de seure!",
  "coffeeMachine1": "Què faria sense la cafetera? Ja que sóc aquí, prendré una mica de cafè...",
  "coffeeMachine2": "Que bo que és! Ara estic al màxim!",
  "coffeeMachine3": "Faré una altra tassa de cafè per emportar-me-la, mai se sap quan es pot necessitar.",
  "coffeeMachine4": "Millor no abusar del cafè, he, he, he.",
  "microwave": "El microones, no podria viure sense ell!",
  "fridge": "El frigorífic està gairebé buit... Hem de fer la compra!",
  "door": "Hora d'anar cap a la feina!",
  "doorFail": "Encara no estic preparat per sortir...",
  "albert": "Albert",
  "noe": "Noe",
  "cobi": "Cobi",
  "officeIntro": "Més tard a l'oficina...",
  "goToDesk": "Abans de començar a treballar puc parlar amb els companys i mirar que hi ha per l'oficina. Per començar a treballar, he d'anar al meu escriptori, que està buit ara mateix.",
  "mf": "Miquel",
  "boss": "Raúl",
  "rs": "Raquel",
  "cc": "Carlos",
  "sn": "Sid",
  "se": "Silvia",
  "rm": "Rafa",
  "ef": "Edgar",
  "ej": "Enric",
  "fs": "Fonsi",
  "wg": "Wilder",
  "ja": "Jack",
  "yf": "Yaiza",
  "mf1": "Albert, Booooooon diiiia! Estic fent una partida al tenis. Vols jugar? A veure qui guanya!",
  "mf2": "Si vols jugar, apropa't a l'arcade i prem el botó d'acció.",
  "mf3": "Després d'aquesta emocionant partida, toca posar-se a pencar!",
  "mf4": "Ara comprovaré que el rendiment de la nova funcionalitat que estem desenvolupant sigui correcte.",
  "arcade1": "Anem a jugar! Que guanyi el millor...",
  "arcade2": "Ja he jugat prou per avui!",
  "pairProgrammingAdded": "Després de la partida, et sents super motivat per treballar en equip! Com a resultat, podràs fer pair programming durant la feina.",
  "mfWon": "He guanyat! El meu entrenament ha donat resultats. Demà juguem de nou, ara és hora de treballar!",
  "mfLost": "He perdut! La propera partida la guanyaré jo, ja ho veuràs! Demà juguem de nou, ara és hora de treballar!",
  "rr1": "Bon dia. Estic revisant uns llibres per a una formació que estic preparant. Espero que us agradi!",
  "cc1": "Hola! Estic monitorant com es comporten els nostres servidors després de l'última pujada a producció.",
  "cc2": "És important veure que tot continua funcionant bé!",
  "rs1": "Bon dia!! Avui he començat una nova tasca, i abans de continuar vull reorganitzar una mica el codi.",
  "rs2": "S'ha de mantenir el codi net i polit!",
  "sn1": "Bon dia, com estàs? M'has agafat prioritzant les tasques que entraran en els propers sprints.",
  "sn2": "Ja veuràs que interessants!",
  "se1": "Hola, bon dia. Estic investigant uns bugs que tenim al sistema. És vital oferir un servei fiable!",
  "rm1": "Hola, noi! Estic millorant el temps d'execució dels tests automatitzats. El feedback dels tests ha de ser ràpid!",
  "ef1": "Ei! M'han passat el nou disseny de la pàgina del perfil de l'usuari, i estic mirant com adaptar-ho a HTML.",
  "ef2": "L'estructura de la pàgina és crítica!",
  "ej1": "Que passa noi? Estic millorant el sistema de logs per tenir més informació si l'usuari té cap",
  "ej2": "problema. Hem de saber que passa a la nostra aplicació!",
  "fs1": "Iep! Ara mateix estic desenvolupant tests unitaris. És imprescindible tenir la nostra aplicació ben testejada!",
  "fs2": "Et dono un dònut de la meva partida secreta, però no li diguis a ningú!",
  "wg1": "Hola, que tal? Estic validant que les tasques que s'han desenvolupat funcionen bé.",
  "wg2": "La qualitat del software ha d'estar assegurada!",
  "ja1": "Bon dia, Albert! Estic contestant dubtes dels usuaris. Una bona atenció al client és molt necessària!",
  "yf1": "Hola, Albert! Si necessiteu ajuda amb qualsevol tema de la feina, aquí estic!",
  "officeBathroom1": "Ara mateix no he d'anar al bany!",
  "officeStuff1": "Aquí hi ha material d'oficina, res interessant.",
  "tv1": "Aquesta TV la fem servir per fer presentacions de diferents tipus, com per exemple presentacions dels nous projectes.",
  "library1": "Hi ha força llibres dedicats al desenvolupament de programari per si necessitem fer cap consulta.",
  "library2": "Agafaré el llibre de Functional-Light-JavaScript, vull repassar uns conceptes que m'ajudaran a resoldre la tasca que estic fent!",
  "library3": "Ja tinc el llibre!",
  "officeMicrowave1": "Òbviament, aquí és on escalfem el menjar!",
  "officeCoffeeMachine1": "Faré un cafè per prendre mentre treballo. Energia!",
  "officeCoffeeMachine2": "De moment ja en tinc prou de cafè!",
  "officeFridge1": "Dins d'aquesta nevera hi ha de tot, no com a casa meva. Moltes coses delicioses!",
  "officeFridge2": "Vinga va! Agafaré un dònut, que sempre vénen de gust.",
  "lockers1": "Dins d'aquest armari podem deixar les nostres pertinences.",
  "diningTable1": "La taula per dinar. Aquí és on ens reunim cada dia i passem una bona estona xerrant entre nosaltres mentre dinem.",
  "meetingRoom1": "A aquesta sala es fan tota mena de reunions, com les planificacions i retrospectives de l'sprint.",
  "myDesk1": "Aquest és el meu escriptori. Potser puc fer un vol abans de treballar. Si vols que comenci a treballar, torna a examinar l'escriptori!",
  "myDesk2": "Ara sí! Hora d'obrir el portàtil i començar.",
  "clothes": "Roba",
  "coffee_cup": "Cafè",
  "coffeeDescription": "(+25 HP)",
  "flj_book": "Llibre F-L JS",
  "fljBookDescription": "(+1 Skill)",
  "notebook": "Portàtil",
  "donut": "Dònut",
  "donutDescription": "(+50 HP)",
  "about": "Info",
  "skills": "Skills",
  "items": "Items",
  "experience": "Experiència →",
  "projects": "Projectes →",
  "name": "Nom:",
  "age": "Edat:",
  "quantity": "Quantitat:",
  "aboutMe": "Nascut a Barcelona. Vaig acabar Enginyeria Informàtica a 2010, i des de llavors he treballat com a desenvolupador de software. Actualment treballo amb PHP i JavaScript.",
  "webPerf": "Perf. Web",
  "mailtrackTitle": "Fullstack Engineer at Mailtrack",
  "mailtrackDates": "Juliol 2018 - Actualitat",
  "mailtrackDescription": "El principal producte de Mailtrack és una extensió de Google Chrome que permet fer seguiment d'emails a Gmail. Per una banda treballo en els serveis de backend, desenvolupats amb PHP i Node.js. Per altra banda treballo a l'extensió, desenvolupada amb TypeScript, CSS i HTML. També faig algunes tasques de sistemes, com configurar Docker o serveis a AWS.",
  "atrapaloLeadTitle": "Lead Frontend Developer at Atrápalo",
  "atrapaloLeadDates": "Juliol 2017 - Juny 2018",
  "atrapaloLeadDescription": "Tech Lead a l'equip de Frontend de la companyia. Les meves funcions eren per una part gestionar l'equip i per altra guiar i desenvolupar l'arquitectura frontend de la web.",
  "atrapaloBackendTitle": "Software Developer at Atrápalo",
  "atrapaloBackendDates": "Gener 2014 - Juliol 2017",
  "atrapaloBackendDescription": "Desenvolupador PHP en un complex sistema amb múltiples tecnologies: RabbitMQ, Elastic, MySQL i Redis entre d'altres.",
  "lcfibTitle": "Becari - Developer at LCFIB",
  "lcfibDates": "Setembre 2008 - Juliol 2010",
  "lcfibDescription": "Vaig treballar amb diferents tecnologies. Per una banda, vaig desenvolupar amb J2EE diferents projectes. També vaig treballar amb Oracle Forms i Oracle Reports. Per últim, vaig treballar amb PHP i MySQL al portal de vídeos de la FIB.",
  "carverTitle": "J2EE Developer at Carver Advanced Systems",
  "carverDates": "Setembre 2010 - Gener 2014",
  "carverDescription": "Desenvolupador J2EE i Oracle SQL fent una aplicació d'assegurances. La aplicació gestionava i tarifava assegurances de diferents àmbits.",
  "nsbTitle": "NoSoloBits Site",
  "nsbDescription": "NoSoloBits és una plana web dedicada a jocs retro. La part backend està feta amb PHP i MySQL. La part frontend està feta amb HTML, JS i SASS, compilat amb Webpack.",
  "easytimerTitle": "Easytimer.js",
  "easytimerDescription": "Easytimer.js és una petita utilitat feta amb JS que permet gestionar de forma fàcil un cronòmetre i un compte enrere.",
  "gameTitle": "Aquest Videojoc!",
  "gameDescription": "El videojoc al qual estàs jugant ara mateix. M'he sortit de la meva zona de confort per a fer-ho, ja que no sóc dissenyador de videojocs. El resultat ha sigut un joc senzill i curtet, però crec que igualment és una bona carta de presentació. Li he posat molta il·lusió, espero que t'agradi!",
  "code": "Codi",
  "codePageDescription": "Escriu codi per atacar al bug.",
  "enemyDamaged": "El teu codi ha fet {{ damage }} punts de mal al bug!",
  "playerDamaged": "El bug t'ha fet {{ damage }} punts de mal.",
  "coffeeEffect": "Et prens el cafè i et sents molt més enèrgic. T'ha fet recuperar {{ hp }} punts de vida.",
  "donutEffect": "Et menges el dònut amb molta gana! T'ha fet recuperar {{ hp }} punts de vida.",
  "bookEffect": "Llegeixes un capítol que et deixa més clar com aplicar Programació Funcional. Ara tens un nou skill disponible!",
  "debug": "Debug",
  "debugDescription": "(Atac ↑)",
  "pairProgramming": "Pair Programming",
  "pairProgrammingDescription": "(Def ↑)",
  "functionalProgramming": "Functional Prog.",
  "functionalProgrammingDescription": "(S. Atac)",
  "unitTesting": "Unit Testing",
  "unitTestingDescription": "(Torn Extra)",
  "battleTimeToWork": "Hora de treballar! Hem d'acabar una tasca força important que hem d'entregar demà.",
  "battleTimeToWork2": "Sembla que tot està perfecte...",
  "battleSomethingIsWrong": "Oh no! Alguna cosa no va bé!",
  "battleBugFound": "Hem trobat un bug ben fotut! Hem d'acabar amb ell abans que sigui massa tard!",
  "battleTutorial": "Per acabar amb el bug puc fer 3 coses al menú: Escriure codi, fer servir una habilitat (skill) o utilitzar objectes.",
  "attackPowerUpDescription": "Fer debugging t'ajuda a identificar punts febles del bug, augmentant els teus 2 pròxims atacs!",
  "defensePowerUpDescription": "Fer pair programming us fa molt més eficaços , augmentant la defensa durant 2 torns!",
  "extraTurnPowerUpDescription": "Fer refactoring i unit testing us fa detectar casos no controlats, guanyant 2 torns extra!",
  "fired": "Estàs acomiadat",
  "refresh": "Refresca la pàgina si vols jugar de nou!",
  "tip": "Consell: Busca objectes per fer servir a la batalla",
  "endingStory": "Després de derrotar al perillós bug, t'adones que estàs fet per caçar a totes aquestes bèsties que fan perillar el software del món sencer. Sense dubtar, et poses mà a l'obra lluitant amb totes les teves forces, arribant fins i tot al mateix infern, on s'originen aquests éssers malignes. La llegenda del Bug Slayer ha començat...",
  "thankYou": "Gràcies per jugar!"
}
